import { createConfigWall } from "../../helpers/wallData";
import { typeWallFoodit, typeWallLaNacion } from "./typeWalls";

export const getWallData = (wallName) => {
    switch (wallName) {
        case "Foodit":
            return createConfigWall(wallName, typeWallFoodit);
        case "LN":
        case "Landing":
        case "Voluntario":
        case "Landing":
        case "Metered":
        case "Cerrado":
        case "PDF":
        case "Familiar":
        case "Club":
        case "Insuficiente":
        case "Normal":
        default:
            return createConfigWall(wallName, typeWallLaNacion);
    }
};



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/configWalls/getWallData.js